import React from 'react';
import QuestionGroupHeader from '../question-group-components/QuestionGroupHeader';
import QuestionGroupActions from '../question-group-components/QuestionGroupActions';
import { useFlowsProgression } from '../../../../../hooks/useFlowsProgression';
import AdvisoryFlowMainContainer from './AdvisoryFlowMainContainer';
import QuestionGroupBody from '../question-group-components/QuestionGroupBody';
import QuestionGroupWrapper from '../question-group-components/QuestionGroupWrapper';

const AdvisoryFlowLayout: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { nextQuestion, previousQuestion } = useFlowsProgression();
  return (
    <AdvisoryFlowMainContainer>
      {/* Header */}
      <QuestionGroupHeader />
      {/* Body */}
      <QuestionGroupBody>
        <QuestionGroupWrapper />
      </QuestionGroupBody>
      {/* Action container */}
      <QuestionGroupActions
        onBack={previousQuestion}
        onContinue={nextQuestion}
      />
    </AdvisoryFlowMainContainer>
  );
};

export default AdvisoryFlowLayout;
